import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icons/icon-close-dark.svg'


const _hoisted_1 = { class: "content-carousel" }
const _hoisted_2 = {
  key: 1,
  class: "content-floorplan-builder-quote"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "controls-color-desktop"
}
const _hoisted_5 = { class: "controls-colors" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-exit-interiors" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.showFloorplan)
      ? (_openBlock(), _createBlock($setup["BuilderEstimatorHouseCustomizeSlider"], {
          key: 0,
          showArrows: true,
          wrapAround: true,
          sliderImages: $props.sliderImages
        }, null, 8, ["sliderImages"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "floorplan-image",
            src: $props.selectedHouseDesign?.floorplans[0].url
          }, null, 8, _hoisted_3)
        ])),
    ($props.showColorsControls && $props.isDesktop && !$props.showFloorplan)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "label" }, "Compare colours", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "line-separator" }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.getColorsSelection, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "select-color",
                style: _normalizeStyle({ 'background-color': item?.color }),
                onClick: ($event: any) => ($setup.onSelectColor(item))
              }, null, 12, _hoisted_6))
            }), 256))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode($setup["BuilderEstimatorHouseLightboxImages"], {
      isOpen: $props.isImageFloorplanModalOpen,
      imageUrl: $props.selectedHouseDesign?.floorplans[0]?.url,
      zoom: $props.zoom,
      onUpdateZoom: $setup.updateZoom,
      onClose: $setup.closeImageModal
    }, null, 8, ["isOpen", "imageUrl", "zoom"]),
    (($props.showExitInteriorsButton && $props.sliderImages.length > 0) || $props.showFloorplan)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "exit-interiors-container",
          onClick: $setup.exitInteriors
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString($props.showFloorplan ? "Close floor plan" : $props.isDesktop ? "Exit Interiors" : "Hide Interiors"), 1),
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            class: "logo-close",
            src: _imports_0
          }, null, -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}